/**
 * workflow-core
 *
 * Copyright (c) Ballerine
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */
import Ajv from 'ajv';
import { CollectionFlowConfigSchema } from '../schemas/config-schema.js';

var ajv = new Ajv({
  strict: true,
  allErrors: true
});
var isCollectionFlowInputConfigValid = ajv.compile(CollectionFlowConfigSchema);

export { isCollectionFlowInputConfigValid };
//# sourceMappingURL=index.js.map
